import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";

const isSandboxCrmValid = (crm?: IntegrationService): boolean => {
  if (!crm) {
    return false;
  }
  return Object.values(IntegrationService).includes(crm);
};

export default isSandboxCrmValid;
